var map = {
	"./amount.svg": "kma1",
	"./area.svg": "dAff",
	"./calculate.svg": "4UEi",
	"./cascader.svg": "kBHh",
	"./checkbox.svg": "3emT",
	"./color.svg": "aD/R",
	"./component.svg": "7O4O",
	"./date-range.svg": "XLC+",
	"./date.svg": "UG5E",
	"./dept.svg": "pXlK",
	"./input.svg": "j5dK",
	"./number.svg": "iE5G",
	"./password.svg": "cYqS",
	"./radio.svg": "BPc1",
	"./rate.svg": "Zpeb",
	"./row.svg": "vAwl",
	"./select.svg": "xzEH",
	"./slider.svg": "IbdX",
	"./switch.svg": "sCeV",
	"./table.svg": "hPfH",
	"./textarea.svg": "Q8b8",
	"./time-range.svg": "ebrj",
	"./time.svg": "wu5P",
	"./upload.svg": "otuq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Y1J4";


//////////////////
// WEBPACK FOOTER
// ./src/components/approverFlow/DynamicForm/icons/svg nonrecursive \.svg$
// module id = Y1J4
// module chunks = 104